import { assign, filter, some } from 'lodash';
import valueFilters from '../valueFilters';
import validator from '../validator';
import modelFactory, { IModel } from '../modelFactory';
import model from './model';
import arrayItemFactory, { IArrayItem } from './arrayItemModel';
import { IModelSet } from '../modelSet';

export interface IUser extends IModel {
	userName?: string;
	roles: IModelSet<IArrayItem>;
	claims: IModelSet<IArrayItem>;
	primaryModule?: string;
	currentPassword?: string;
	password?: string;
	hasModule(key: string): boolean;
	hasFeature(moduleKey: string, featureKey: string, explicit?: boolean): boolean;
	hasClaim(key: string);
	isPrimaryModule(key: string): boolean;
	setClaim(key: string, enabled?: boolean): void;
}

const userFactory = modelFactory.createFactory<IUser>('User', assign({}, model, {
	userName: {
		setFilters: valueFilters.clean,
		rules: validator.required()
	},
	roles: {
		defaultValue: [],
		setFilters: valueFilters.toModelSet(arrayItemFactory)
	},
	claims: {
		defaultValue: [],
		setFilters: valueFilters.toModelSet(arrayItemFactory)
	},
	primaryModule: {
		setFilters: valueFilters.clean
	},
	currentPassword: {
		setFilters: valueFilters.clean
	},
	password: {
		setFilters: valueFilters.clean
	},
	hasModule: function (key) {
		return some(this.claims, function (claim) {
			const normalized = claim.key.replace('-*', '');

			return normalized.indexOf(key) === 0;
		});
	},
	hasFeature: function (moduleKey, featureKey, explicit) {
		const key = moduleKey + '-' + featureKey;

		return some(this.claims, function (claim) {
			const normalized = (explicit) ? claim.key : claim.key.replace('-*', '');

			return key.indexOf(normalized) === 0;
		});
	},
	hasClaim: function (key) {
		const result = some(this.claims, function (claim) {
			if (claim.key.indexOf('-*') !== -1) {
				return key.indexOf(claim.key.replace('-*', '')) === 0;
			}
			return key === claim.key;
		});

		return result;
	},
	isPrimaryModule: function (key) {
		return this.primaryModule === key;
	},
	setClaim: function (key, enabled) {
		const isWildcard = key.indexOf('-*') !== -1;
		// reset any related claims
		let result = (isWildcard) ? filter(this.claims.toDocumentArray(), c => { return c === key || c.indexOf(key.replace('-*', '')) === -1; }) : this.claims.toDocumentArray();

		if (!enabled && this.hasClaim(key)) {
			result = filter(result, c => c !== key);
		}
		else if (!!enabled && !this.hasClaim(key)) {
			result.push(key);
		}

		this.claims = result;
	}
}));

export default userFactory;